// extracted by mini-css-extract-plugin
export default {"banner":"Banner-module_banner__W1eTo","icon":"Banner-module_icon__HsX6s","subHeader":"Banner-module_subHeader__GmAqe","emSubText":"Banner-module_emSubText__pJ5I8"};